
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ClueService } from '@/services/index'
import { isNumber } from 'lodash'
import { IClue } from '@/types/clue-types'
import LatestClueTable from './components/latestClueTable.vue'
import ReportedDialog from './components/reportedDialog.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import FullLoading from '@/components/full_loading/index.vue'

enum Table {
    channel = 'channel',
    source = 'clue_source'
}
enum InputType {
    channel = 'channel',
    source = 'source'
}
enum SELECT_TYPE {
    ALL = 0,
    SOURCE = 1,
    USER = 2
}
const searchType = {
    query: {
        key: 1, name: '关键词搜索'
    },
    userId: {
        key: 2, name: 'user_id搜索'
    }
}

@Component({
    components: {
        LatestClueTable,
        ReportedDialog,
        ScrollTo,
        FullLoading
    }
})
export default class ClueLatest extends Vue {
    @Ref('channelRef') private channelRef: any
    @Ref('sourceRef') private sourceRef: any
    @Ref('reportDialog') private reportDialog: any
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private selectType = SELECT_TYPE.ALL  // 源线索 or 用户报料
    private type = 0    // 过滤条件
    private curSearchType = searchType.query.key
    private searchType = searchType
    private InputType = InputType
    private query = ''
    private sourceInput = ''
    private typeSelect = ''
    private typeInput = ''
    private isLoading = true
    private pageTotal = 0
    private pageIndex = 1
    private pageSize = 15
    private clueTypeId: undefined | number = undefined
    private channelId = 0
    private clueSourceId = 0
    private sort = 'created_at'
    private clueData: any[] = []
    private clueSortList: any[] = []
    private audit = '-1'
    // 是否作用于新增报道媒体
    private isReported = false
    private curClue: any = ''

    get matchPlaceholder() {
        return this.curSearchType === searchType.query.key ? '请输入关键词' : '请输入user_id'
    }

    created() {
        if (this.$route.query.reported) {
            this.isReported = true
        }
    }
    async mounted() {
        await Promise.all([
            this.getClueTypeList(),
            this.initData()
        ])
        this.isLoading = false
    }
    private onExamineChange({ target, val }: any) {
        this.onSwitchChange(val, target)
    }
    private onSelectTypeChange() {
        this.typeSelect = ''
        this.clueTypeId = undefined
        this.initData()
    }

    private async onSwitchChange(status: any, channel: any) {
        const params = {
            id: channel.id,
            status: status
        }
        const result = await ClueService.updateChannelShow(params)
        if (result.status === 200) {
            channel.status = status
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '修改状态失败, 请稍后再试')
    }

    private onLookDetail(id: number | string) {
        const query = {}
        if (this.isReported) Reflect.set(query, 'report', '1')
        const { href } = this.$router.resolve({
            query,
            name: 'ClueDetail',
            params: { id: String(id) }
        })
        window.open(href, '_blank')
    }

    private onDelete(id: number) {
        this.$confirm('是否确定删除此线索?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.isLoading = true
            let result = await this.deleteClue(id)
            result && await this.initData()
            this.isLoading = false
        })
    }

    private async deleteClue(id: number) {
        const params = { id }
        const result = await ClueService.deleteClue(params)
        if (result.status === 200) {
            this.$msuccess('删除线索成功')
            return true
        }
        return this.$merror(result.message || '发生错误, 请稍后再试')
    }

    /** 获取线索列表 */
    private async initData() {
        const isShow = +this.audit === -1 ? undefined : +this.audit
        const params = { 
            page_index: this.pageIndex,
            page_size: this.pageSize,
            clue_type_id: isNumber(this.clueTypeId) ? +this.clueTypeId : undefined,
            channel_id: this.channelId || undefined,
            user_report: this.selectType,
            clue_source_id: this.clueSourceId || undefined,
            sort: this.sort || '',
            status: isShow,
            query: this.curSearchType === searchType.query.key ? this.query : undefined,
            user_id: this.curSearchType === searchType.userId.key ? this.query : undefined
        }
        const result = await ClueService.getClueList(params)
        if (result.status === 200) {
            const { list, page_total } = result.data
            this.clueData = list.map((clue: IClue) => {
                clue.top = clue.top === 1 ? true : false
                return clue
            })
            this.pageTotal = page_total
        }
    }

    /** 获取线索类别列表 */
    private async getClueTypeList() {
        const result = await ClueService.getClueSortList()
        if (result.status === 200) {
            this.clueSortList = result.data
        }
    }

    private onSuggestInputSelect(activeItem: any, type: InputType) {
        if (type === InputType.channel) {
            this.channelId = activeItem.id
        } else if (type === InputType.source) {
            this.clueSourceId = activeItem.id
        }
        this.initData()
    }

    private async getSuggestion(keyword: string ,table: string) {
        const params = { keyword, table }
        const transformMap = (item: any) => ({ id: item.id, value: item.name })
        const result = await ClueService.suggestTip(params)
        if (result.status === 200) {
            return result.data.list.map(transformMap)
        }
        return []
    }

    // 搜索建议
    private async getSuggestList(queryString: string, cb: Function, type: InputType) {
        let table = ''
        let ref
        if (type === InputType.channel) {
            table = Table.channel
            ref = this.channelRef
        } else if (type === InputType.source) {
            table = Table.source
            ref = this.sourceRef
        }
        if (!table || !ref) return
        cb(await this.getSuggestion(queryString, table));
        (ref as any).handleFocus()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.initData)
    }

    private onTypeSelectChange(val: any) {
        this.clueTypeId = val
        this.initData()
    }

    private onAutoComplete(e: Event, type: InputType) {
        const className = (e.target as HTMLElement).className
        if (className.includes('el-icon-circle-close')) {
            if (type === InputType.channel) {
                this.channelId = 0
            } else if (type === InputType.source) {
                this.clueSourceId = 0
            }
            this.initData()
        }
    }

    private onReport(clue: any) {
        this.curClue = clue
        this.reportDialog.show()
    }

    private async onChangeTop({ status, id }: { status: number, id: number }) {
        const params = {
            id,
            top: status ? 1 : 0
        }
        const result = await ClueService.updateClueTop(params)
        if (result.status === 200) {
            const targetClue = this.clueData.find(item => item.id === id)
            if (targetClue) {
                targetClue.top = status
            }
            this.$message({
                type: 'success',
                message: '切换成功',
                showClose: true
            })
            return
        }
        const targetClue = this.clueData.find(item => item.id === id)
        if (targetClue) {
            targetClue.top = !status
        }
        this.$message({
            type: 'error',
            message: '切换失败, 请稍后再试'
        })
    }

    /** 新增报道线索 */
    private async createClueReport(params: any) {
        const result = await ClueService.createClueReported(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '线索报道成功',
                showClose: true
            })
            return this.reportDialog.hide()
        }
        this.$message({
            type: 'error',
            message: '发生错误, 线索报道失败',
            showClose: true
        })
        this.reportDialog.stopLoading()
    }

    private onUpdated() {
        this.initData()
    }

    private onTimeChange(val: string) {
        this.sort = val
        this.initData()
    }

    private onAuditChange() {
        this.initData()
    }

    onReGetData() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.clueData = []
        this.initData()
    }
}
